"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) {
    if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withLDConsumer = exports.withLDProvider = exports.useLDClientError = exports.useLDClient = exports.useFlags = exports.camelCaseKeys = exports.asyncWithLDProvider = exports.LDProvider = void 0;

var provider_1 = __importDefault(require("./provider"));

exports.LDProvider = provider_1.default;

var withLDProvider_1 = __importDefault(require("./withLDProvider"));

exports.withLDProvider = withLDProvider_1.default;

var asyncWithLDProvider_1 = __importDefault(require("./asyncWithLDProvider"));

exports.asyncWithLDProvider = asyncWithLDProvider_1.default;

var withLDConsumer_1 = __importDefault(require("./withLDConsumer"));

exports.withLDConsumer = withLDConsumer_1.default;

var useFlags_1 = __importDefault(require("./useFlags"));

exports.useFlags = useFlags_1.default;

var useLDClient_1 = __importDefault(require("./useLDClient"));

exports.useLDClient = useLDClient_1.default;

var useLDClientError_1 = __importDefault(require("./useLDClientError"));

exports.useLDClientError = useLDClientError_1.default;

var utils_1 = require("./utils");

Object.defineProperty(exports, "camelCaseKeys", {
  enumerable: true,
  get: function get() {
    return utils_1.camelCaseKeys;
  }
});

__exportStar(require("./types"), exports);